var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconConf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 157.66 134.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cristaux"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m157.63,43.11h.03v1.64c0,18.18-11.66,33.64-27.91,39.32l7.35,32.7-.21.17-24.57-30.54h-21.67c0-.21,0-.41-.01-.62h.02v-1.16c0-16.21-13.14-29.35-29.35-29.35-.3,0-.6.01-.9.02v-.02h-30.07c-.87-3.36-1.34-6.89-1.34-10.52,0-.49,0-.97.03-1.46h-.03v-1.64C29,18.65,47.65,0,70.65,0c.43,0,.85.01,1.28.02v-.02h44.08c23,0,41.65,18.65,41.65,41.65,0,.49-.01.97-.03,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m86.66,85.81c0-14.76-12.56-26.72-28.06-26.72-.29,0-.57,0-.86.01v-.02h-28.81s-.88,0-.88,0c-15.49,0-28.06,11.96-28.06,26.72,0,.31,0,.62.02.93h-.02v1.05c0,11.67,7.85,21.58,18.8,25.22l-4.95,20.98.14.11,16.55-19.59h26.96s1.1,0,1.1,0c15.49,0,28.06-11.96,28.06-26.72,0-.31,0-.62-.02-.93h.02v-1.05Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConf);
export default __webpack_public_path__ + "static/media/icon_conf.f45ffd1b906cbed83a1c9738efb62ea5.svg";
export { ForwardRef as ReactComponent };